var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-col",
        { staticClass: "pa-0" },
        [
          _c("span", [_vm._v("Тип организатора*")]),
          _c("v-select", {
            attrs: {
              id: "profileType",
              dense: "",
              outlined: "",
              "item-value": "value",
              "item-text": "title",
              clearable: "",
              disabled: _vm.disabled,
              loading: _vm.loading,
              items: _vm.allowedProfiles,
              value: _vm.profileType,
              "error-messages": _vm.profileTypeError,
            },
            on: {
              input: function ($event) {
                return _vm.$emit("input:profile-type", $event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "pa-0" },
        [
          _c("span", [_vm._v("Организатор*")]),
          _c("v-autocomplete", {
            attrs: {
              "item-text": "name",
              "item-value": "id",
              outlined: "",
              dense: "",
              "hide-no-data": "",
              clearable: "",
              "auto-select-first": "",
              "hide-selected": false,
              items: _vm.profileType ? _vm.profiles[_vm.profileType] : [],
              loading: _vm.loading || _vm.isLoadingData,
              disabled: _vm.disabled,
              "error-messages": _vm.profileIdError,
              value: _vm.profileId,
            },
            on: {
              change: function ($event) {
                return _vm.$emit("input:profile-id", $event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "selection",
                fn: function (data) {
                  return [
                    _c(
                      "router-link",
                      _vm._b(
                        { attrs: { to: _vm.redirectToProfile(data.item.id) } },
                        "router-link",
                        data.attrs,
                        false
                      ),
                      [_vm._v(_vm._s(data.item.name))]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }